import runtimeConfig from '../../runtimeConfig';
import React, { useState, useEffect } from "react";
import server from "../../api/server";
import { toast } from "react-toastify";
import { useGoogleLogin } from '@react-oauth/google';
import { FaMicrosoft } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import ModernTimeDropdown from "../layouts/modernDropdown";
import { useToast } from '../../context/ToastContext.jsx';
import { setAccessTokenExpiresAt, scheduleAccessTokenRefresh } from '../../utils/dashboardAuth';

function msRedirectUri() {
  return runtimeConfig.REACT_APP_MICROSOFT_REDIRECT_URI;
}
function msAuthority() {
  return 'common'
}
function msStripOAuthParams(search) {
  const p = new URLSearchParams(search);
  ['code', 'state', 'session_state'].forEach((k) => p.delete(k));
  const s = p.toString();
  return s ? `?${s}` : '';
}

const CreateNewLogin = ({showCreateLogin}) => {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [show, setShow] = useState(false)
    const [name, setName] = useState(null)
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)
    const [organization, setOrganization] = useState(null)
    const [industry, setIndustry] = useState(null)
    const [numberOfAgents, setNumberOfAgents] = useState(null)
    const [showOTPInput, setShowOTPInput] = useState(false);
    let [resendAllowed, setResendAllowed] = useState(false);
    let [countdown, setCountdown] = useState(60);
    let [apiCallRunning, setApiCallRunning] = useState(false);
    let [otp, setOTP] = useState("");
    const [isVerified, setIsVerified] = useState(false)
    const isMobile = window.innerWidth <= 768;
    const [currPage, setCurrPage] = useState(1)
    const [isGoogleLogin, setIsGoogleLogin] = useState(false)
    const [isMicrosoftLogin, setIsMicrosoftLogin] = useState(false)
    const [error, setError] = useState("");
    const microsoftClientId = runtimeConfig.REACT_APP_MICROSOFT_CLIENT_ID;
    useEffect(() => {
        setShow(true);
        }, []);
    useEffect(() => {
              let timer;
              if (countdown > 0 && !resendAllowed) {
                  timer = setInterval(() => {
                      setCountdown((prev) => {
                          if (prev <= 1) {
                              setResendAllowed(true); // Allow resend after countdown reaches zero
                              clearInterval(timer);
                              return 0;
                          }
                          return prev - 1;
                      });
                  }, 1000);
              }
              return () => clearInterval(timer); // Cleanup on unmount or countdown change
          }, [countdown, resendAllowed]);

      const handleCreateNewUser = async () => {
        if(apiCallRunning){
            return;
        }
        if(!name || !email || !organization || !industry || !numberOfAgents){
            showToast("All fields are required.", "error");
            return;
        }
        const orgTrimmed = (organization || '').trim();
        if (orgTrimmed.length === 0) {
            showToast("Organisation name cannot be empty or spaces only.", "error");
            return;
        }
        setOrganization(orgTrimmed)
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).+$/; // At least one letter and one number
    
        if(!isGoogleLogin && !isMicrosoftLogin){
            if (!password) {
                showToast("Please enter your new password and confirm new password", "error");
                return;
            }else if (password.length < 8) {
                showToast("New password must be at least 8 characters", "error");
                return;
            } else if (!passwordRegex.test(password)) {
                showToast("New password must contain at least one letter and one number", "error");
                return;
            }
        }
            try {
                setApiCallRunning(true);
                let response = await server.createNewOrgansationUser(email, password, name, orgTrimmed, industry, numberOfAgents, isGoogleLogin, isMicrosoftLogin);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("New Account Created Successfully", "success");
                    showCreateLogin(false);
                }else{
                    let resp = await response.json()
                    if(resp.error){
                        showToast(resp.error, "error");
                    }else{
                        showToast("Try again later.", "error");
                    }
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
      }
      const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };
      const isBusinessEmail = (email) => {
        // Common free email providers to check against
        const freeEmailProviders = [
          'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 
          'aol.com', 'icloud.com', 'protonmail.com', 'mail.com',
          'zoho.com', 'yandex.com', 'gmx.com', 'googlemail.com'
        ];
        
        if (!isValidEmail(email)) return false;
        
        const domain = email.split('@')[1].toLowerCase();
        return !freeEmailProviders.includes(domain);
      };
      const handleSendOTP = async () => {
        setShowOTPInput(true)
        if(apiCallRunning){
            return;
        }
        if(!email){
            showToast("Please enter your email", "error");
        }else if(!isValidEmail(email)){
            showToast("Please enter a valid email", "error");
        }else if(!isBusinessEmail(email)){
            showToast("Please enter a valid business email", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.sendVerificationOTP(email, 'first_time_user');
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("Verification code sent to your email", "success");
                    setCountdown(60);
                    setResendAllowed(false);
                }else if(response.status===404){
                    showToast("User not found", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleOTPVerification = async () => {
        if(apiCallRunning){
            return;
        }
        if(!otp){
            showToast("Please enter your OTP", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.otpValidation(email, otp);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("OTP verified successfully", "success");
                    setShowOTPInput(false)
                    setIsVerified(true)
                }else if(response.status === 400){
                    showToast("Invalid or expired OTP", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleOTPResend = async () => {
        if(apiCallRunning){
            return;
        }
        if(!email){
            showToast("Please enter your email", "error");
        }else if(!isValidEmail(email)){
            showToast("Please enter a valid email", "error");
        }else if(!isBusinessEmail(email)){
            showToast("Please enter a valid business email", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.sendVerificationOTP(email);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("OTP resent successfully", "success");
                    setShowOTPInput(true);
                    setCountdown(60);
                    setResendAllowed(false);
                }else if(response.status===404){
                    showToast("User not found", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }

    // Get the intended destination URL from query parameters
    const getIntendedDestination = () => {
        const params = new URLSearchParams(location.search);
        const redirectFromParams = params.get('redirect') || params.get('intended');
        
        // Also check sessionStorage for embedded auth redirects
        const redirectFromStorage = sessionStorage.getItem('intendedRedirect');
        
        // Clear the stored redirect after retrieving it
        if (redirectFromStorage) {
            sessionStorage.removeItem('intendedRedirect');
        }
        
        return redirectFromParams || redirectFromStorage;
    };

    const handleApiCheck = async(info, services, session_id, access_token_expires_at) => {
    
          if (info.client_id && info.email) {
            let userData = null;
            
            userData = {
                email: info.email,
                client_id: info.client_id,
                service_id: info.service_id,
                loginTime: new Date().getTime(),
                role: info.role,
                name: info.name,
                'session_id': session_id
              };
            userData['services'] = services
            // Save user session data in cookies (expire in 12 hours)
            const currentDate = new Date();
    
            // Set the expiry date to 30 days from now
            currentDate.setTime(currentDate.getTime() + (30 * 24 * 60 * 60 * 1000));
    
            // Format the expiry date in UTC format
            const expires = `expires=${currentDate.toUTCString()}`;
    
            // Set the cookie with the expiration time
            document.cookie = `dashboard_login_user_creds=${JSON.stringify(userData)}; ${expires}; path=/; Secure; SameSite=None`;

            if (access_token_expires_at) {
                setAccessTokenExpiresAt(access_token_expires_at);
                scheduleAccessTokenRefresh(server);
              }
            
            // Check if there's an intended destination URL
            const intendedDestination = getIntendedDestination();
            if (intendedDestination) {
              // Decode the URL and navigate to it
              try {
                const decodedUrl = decodeURIComponent(intendedDestination);
                navigate(decodedUrl);
              } catch (error) {
                // Fallback to default navigation if URL decoding fails
                navigate(`/analytics/${userData.client_id}/DEFAULT/home`);
              }
            } else {
              // Default navigation
              navigate(`/analytics/${userData.client_id}/DEFAULT/home`);
            }
        } else {
          showToast('Access Denied!', "error");
        }
      }

    const handleChangeOrg = (e) => {
        const value = e.target.value;
        const alphanumericWithSpaceRegex = /^[a-zA-Z0-9 ]*$/;
        
        if (!alphanumericWithSpaceRegex.test(value)) {
          setError("Only alphanumeric characters and spaces are allowed");
          return;
        }
        
        if (value.length <= 30) {
          setOrganization(value.toUpperCase());
          setError(""); // Clear error when within limit
        } else {
          setError("Maximum 30 characters allowed");
        }
    };

    const handleGoogleLogin = useGoogleLogin({
        redirectUri: 'https://anthropod.in/dashboard/oauth2callback',
        scope: 'profile email', // Add scopes here
        onSuccess: async (code) => {
            const { access_token } = code;
            try {
                // Fetch user's Google profile details using the access_token
                let userInfoResponse = await fetch(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${access_token}`);
                let userInfo = await userInfoResponse.json();
                
                // You now have access to the user's name and email
                const { name, email } = userInfo; // Extract name and email
    
                // Now you can use this information as needed
                let response = await server.googleLogin(access_token);
                let resp = await response.json();
                if(response.status === 200){
                    if(resp.info && resp.info.role && resp.info.role === 'superadmin'){
                        setName(name)
                        setEmail(email)
                        setIsVerified(true)
                        setShowOTPInput(false)
                        setIsGoogleLogin(true)
                        setIsMicrosoftLogin(false)
                        return;
                    }
                    showToast("Login successful", "success");
                    handleApiCheck(resp.info, resp.services, resp.session_id, resp.access_token_expires_at)
                }else if(resp.error.includes('User not found') || resp.error.includes('Account does not exist.')){
                    setName(name)
                    setEmail(email)
                    setIsVerified(true)
                    setShowOTPInput(false)
                    setIsGoogleLogin(true)
                    setIsMicrosoftLogin(false)
                }
            } catch (error) {
                console.error('Error logging in:', error);
            }
        },
        onError: (error) => {
            console.error('Login Failed:', error);
        },
    });    
    const handleMicrosoftLogin = () => {
        if (!microsoftClientId) {
            showToast('Microsoft login is not configured.', 'error');
            return;
        }
        const params = new URLSearchParams({
            client_id: microsoftClientId,
            response_type: 'code',
            redirect_uri: msRedirectUri(),
            response_mode: 'query',
            scope: 'openid profile email User.Read',
            state: 'ms_create',
        });
        window.location.href = `https://login.microsoftonline.com/${msAuthority()}/oauth2/v2.0/authorize?${params.toString()}`;
    };
    useEffect(() => {
        const q = new URLSearchParams(location.search);
        const code = q.get('code');
        if (!code || q.get('state') !== 'ms_create') return;

        const dedupeKey = `ms_handled_${code}`;
        if (sessionStorage.getItem(dedupeKey)) return;
        sessionStorage.setItem(dedupeKey, '1');

        navigate(`${location.pathname}${msStripOAuthParams(location.search)}`, { replace: true });

        (async () => {
            try {
                const response = await server.microsoftLogin(code);
                const resp = await response.json();

                const profileFromResp = () => {
                    if (resp.info?.name && resp.info?.email) {
                        return { name: resp.info.name, email: resp.info.email };
                    }
                    const u = resp.microsoft_user || resp.microsoft_profile || resp.user;
                    if (u && (u.email || u.mail)) {
                        return { name: u.name || u.displayName || '', email: u.email || u.mail || u.userPrincipalName };
                    }
                    return null;
                };

                if (response.status === 200) {
                    if(resp.info && resp.info.role && resp.info.role === 'superadmin'){
                        const p = profileFromResp();
                        setName(p?.name ?? resp.info.name ?? '')
                        setEmail(p?.email ?? resp.info.email ?? '')
                        setIsVerified(true)
                        setShowOTPInput(false)
                        setIsMicrosoftLogin(true)
                        setIsGoogleLogin(false)
                        return;
                    }
                    showToast("Login successful", "success");
                    handleApiCheck(resp.info, resp.services, resp.session_id, resp.access_token_expires_at)
                } else if ((resp.error || '').includes('User not found') || (resp.error || '').includes('Account does not exist.')) {
                    const p = profileFromResp();
                    if (p?.email) {
                        setName(p.name || '')
                        setEmail(p.email || '')
                        setIsVerified(true)
                        setShowOTPInput(false)
                        setIsMicrosoftLogin(true)
                        setIsGoogleLogin(false)
                    } else {
                        showToast(resp.error || 'Some error occured.', 'error');
                    }
                } else {
                    showToast(resp.error || 'Some error occured.', 'error');
                }
            } catch (error) {
                console.error('Microsoft Login Failed:', error);
                showToast(error.message || 'Some error occured.', 'error');
            }
        })();
    }, [location.search]);
    const handleNextPage = () => {
        if(isVerified){
            setCurrPage(2)
        }else{
            showToast('Email verification pending!', "error");
        }
    }

  return (
    <div className="fixed top-0 right-0 h-full bg-white transition-transform" style={{ transform: show ? 'translateX(0)' : 'translateX(100%)', width: (!isMobile) ? "50%":"100%", transitionDuration: "1s", overflowY: "scroll" }}>
        <div className="max-w-md mx-auto p-6" style={{maxWidth: "31rem"}}>
        <button onClick={()=> {showCreateLogin(false);}} style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '24px' }}>✖</button>
        <h2 className="text-2xl font-bold text-center mb-6">Create New Account</h2>
        {
            currPage === 1 && (
                <div>
                    <div className="flex items-center justify-center mb-6">
                        <div className="flex items-center">
                            <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center font-bold">
                            1
                            </div>
                            <div className="w-20 h-1 bg-gray-300 mx-2"></div>
                            <div className="w-8 h-8 rounded-full bg-gray-300 text-gray-600 flex items-center justify-center font-bold">
                            2
                            </div>
                        </div>
                    </div>
                    <div className="mb-4 text-center text-sm text-gray-600 bg-gray-50 p-3 rounded-md" style={{border: "1px solid #8080806b"}}>
                        <p style={{fontSize: "12px"}}>Already have team members using Anthropod? Ask them to add you as a member instead of creating a new account.</p>
                    </div>
                
                <button onClick={handleGoogleLogin} className="w-full flex items-center justify-center bg-black text-white py-3 rounded-md mb-4">
                    <svg className="mr-2" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M19.99 10.187c0-.82-.069-1.412-.216-2.030h-9.975v3.697h5.537c-.112.863-.728 2.17-2.084 3.037l-.019.125 3.023 2.338.209.021c1.917-1.774 3.026-4.387 3.026-7.488z" fill="#4285F4"></path>
                        <path d="M10.801 20c2.734 0 5.028-.896 6.705-2.442l-3.19-2.47c-.854.591-1.999 1.002-3.515 1.002-2.695 0-4.979-1.774-5.793-4.227l-.125.011-3.141 2.427-.041.112c1.677 3.341 5.194 5.597 9.794 5.597z" fill="#34A853"></path>
                        <path d="M5.008 11.863c-.196-.574-.308-1.189-.308-1.863s.112-1.289.308-1.863l-.007-.132-3.186-2.475-.104.05C1.044 8.27.938 9.103.938 10s.106 1.73.662 2.49l3.408-2.617z" fill="#FBBC05"></path>
                        <path d="M10.801 4.008c1.914 0 3.207.829 3.941 1.521l2.876-2.815C15.816 1.089 13.522 0 10.8 0 6.2 0 2.684 2.256 1.007 5.597l3.396 2.617c.814-2.453 3.099-4.206 5.798-4.206z" fill="#EB4335"></path>
                    </svg>
                    Continue with Google
                </button>
                <button onClick={handleMicrosoftLogin} className="w-full flex items-center justify-center bg-black text-white py-3 rounded-md mb-4">
                    <FaMicrosoft className="mr-2" />
                    Continue with Microsoft
                </button>
                
                <div className="text-center my-4" style={{display: "flex", alignItems: 'center'}}>
                    <hr style={{width: "37%"}}/>
                <span style={{fontSize: "12px", color: "gray", margin: "0 5px"}}>or create with email</span>
                <hr style={{width: "37%"}}/>
                </div>
        <form>
                <div className="mb-4">
                <label htmlFor="fullName" className="block text-gray-700 mb-2">
                    Full Name
                </label>
                <input
                                value={name}
                                type="text"
                                id="fullName"
                                onChange={(e)=>setName(e.target.value)}
                                placeholder="Enter your full name"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${error ? 'border-red-500' : ''}`} style={{width: "28rem"}}
                            />
                </div>
                
                <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700 mb-2">
                    Email ID
                </label>
                <div className="flex gap-2">
                <input
                                value={email}
                                type="email"
                                id="email"
                                disabled={isVerified}
                                onChange={(e)=>setEmail(e.target.value)}
                                placeholder="Enter your email"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${error ? 'border-red-500' : ''}`} style={{width: "28rem"}}
                            />
                    {(!showOTPInput && !isVerified) && <button type="button" className="bg-black text-white px-4 py-2 rounded-lg" style={{width: "35%"}} onClick={handleSendOTP}>
                    Send OTP
                    </button>}
                </div>
                            {
                                showOTPInput && (
                                    <div style={{marginTop: "1rem"}}>
                                    <span className=" text-gray-700 mb-2">OTP</span>
                                    <input
                                value={otp}
                                type="text"
                                onChange={(e)=>setOTP(e.target.value)}
                                placeholder="OTP"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${error ? 'border-red-500' : ''}`} style={{width: "28rem"}}
                            />
                                    {/* <input class="global-input"type="text" onChange={(e)=>setOTP(e.target.value)} placeholder="OTP" style={{padding: '0.5rem', marginBottom: '1rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "50%":"80%", marginLeft: "10px" }} /> */}
                                    <div style={{fontSize: "13px", color: "grey", marginBottom: "0.5rem"}}>You can resend OTP after {countdown} seconds.</div>
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "80%"}}>
                                        <button type="button" onClick={handleOTPResend} style={{padding: '0.5rem', background: (resendAllowed && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", width: (!isMobile) ? "10rem":"7rem" }}>Resend</button>
                                        <button type="button" onClick={handleOTPVerification} style={{padding: '0.5rem', background: (otp && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", width: (!isMobile) ? "10rem":"7rem" }}>Verify</button>
                                    </div>
                                    </div>
                                )
                            }
                </div>
                
                {
                    !(isGoogleLogin || isMicrosoftLogin) && (
                        <div className="mb-4">
                            <label htmlFor="password" className="block text-gray-700 mb-2">
                                Password
                            </label>
                            <div className="relative">
                            <input
                                value={password}
                                type={passwordVisible ? "text" : "password"}
                                id="password"
                                onChange={(e)=> {setPassword(e.target.value)}}
                                placeholder="Enter password"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${error ? 'border-red-500' : ''}`} style={{width: "28rem"}}
                            />
                                <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2" onClick={() => setPasswordVisible(!passwordVisible)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    {passwordVisible ? (
                                    <>
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                    </>
                                    ) : (
                                    <>
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                        <circle cx="12" cy="12" r="3"></circle>
                                    </>
                                    )}
                                </svg>
                                </button>
                            </div>
                        </div>
                    )
                }
            </form>
            <div style={{display: "flex"}}>
                <button onClick={()=> {showCreateLogin(false);}} style={{padding: "10px", width: "50%", margin: "10px", border: "1px solid black", borderRadius: "6px"}}>
                    Back
                </button>
                <button onClick={handleNextPage} style={{padding: "10px", width: "50%", margin: "10px", background: (isVerified) ? "black":"grey", color: "white", borderRadius: "6px"}}>
                    Continue
                </button>
            </div>
        </div>
            )
        }
            {
                currPage === 2 && (
                    <div>
                        <div className="flex items-center justify-center mb-6">
                            <div className="flex items-center">
                                <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center font-bold">
                                1
                                </div>
                                <div className="w-20 h-1 bg-gray-300 mx-2"></div>
                                <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center font-bold">
                                2
                                </div>
                            </div>
                        </div>
                        <form>
                            <div className="mb-4">
                            <label htmlFor="organization" className="block text-gray-700 mb-2">
                                Organisation Name
                            </label>
                            <input
                                value={organization}
                                onChange={handleChangeOrg}
                                type="text"
                                id="organization"
                                placeholder="Enter your organisation name"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${error ? 'border-red-500' : ''}`} style={{width: "28rem"}}
                            />
                            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                            </div>
                            
                            <div className="mb-4">
                            <label htmlFor="industry" className="block text-gray-700 mb-2">
                                Industry
                            </label>
                            <div className="relative">
                            <ModernTimeDropdown width={'w-112'} height="h-10" placeholder="Select industry" value={industry} onChange={(e) => setIndustry(e.target.value)} 
                            options={['Real Estate', 'Insurance', 'Debt Collection',
                                'Banking',
                                'E-commerce',
                                'Financial Services',
                                'Education',
                                'Healthcare',
                                'Rental Services',
                                'Logistics & Supply Chain',
                                'SaaS',
                                'Other'
                                ]}/>
                            </div>
                            </div>
                            
                            <div className="mb-4">
                            <label htmlFor="salesAgents" className="block text-gray-700 mb-2">
                                Number of Sales/Support Agents
                            </label>
                            <div className="relative">
                            <ModernTimeDropdown width={'w-112'} height="h-10" placeholder="Select range" value={numberOfAgents} onChange={(e) => setNumberOfAgents(e.target.value)} options={['1-10', '11-50', '51-100', '101-500', '500+']}/>
                                </div>
                            </div>
                        </form>
                        <div style={{display: "flex"}}>
                            <button onClick={()=> {setCurrPage(1)}} style={{padding: "10px", width: "50%", margin: "10px", border: "1px solid black", borderRadius: "6px"}}>
                                Back
                            </button>
                            <button onClick={handleCreateNewUser} style={{padding: "10px", width: "50%", margin: "10px", background: (name && email && organization && industry && numberOfAgents) ? "black" : "grey", color: "white", borderRadius: "6px"}}>
                                Create
                            </button>
                        </div>
                    </div>
                )
            }
        </div>
    </div>
  );
};

export default CreateNewLogin;